export const proccessError = (cdResult, errorCath) => {
  const errorsArray = cdResult["cdExceptions"] || cdResult["CdExceptions"];
  let tempErrorsArray = [];

  for (let i = 0; i < errorsArray.length; i++) {
    const errorElement = errorsArray[i];
    tempErrorsArray.push(errorElement.exception || errorElement.Exception);
  }

  if (errorCath && tempErrorsArray.length === 0) {
    tempErrorsArray.push(["Error en el servidor"]);
  }

  return tempErrorsArray;
};

export const validateRequired = (data, requireds, properties) => {
  const errors = [];

  if (!requireds) return errors;

  for (let i = 0; i < requireds.length; i++) {
    const field = requireds[i];
    if (!data[field] || (data[field] && data[field] === "")) {
      // get name label
      if (properties && properties[field] && properties[field]["label"]) {
        errors.push(`${properties[field]["label"]}: es requerido`);
      } else {
        errors.push(`${field}: es requerido`);
      }
    }
  }

  return errors;
};
